import { createContext, type ReactNode, useContext } from 'react'

export const SupportHeaderSlotContext = createContext<ReactNode>(null)

export const SupportHeaderSlot = () => useContext(SupportHeaderSlotContext)
